<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">Custom Domain</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="box p-0">
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<div class="text">Custom Domain</div>
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="isShowModalCustomDomains = true">+ Add Custom Domain</button>
							</div>
						</div>
						<integration-accounts
							:name="'Custom Domains'"
							:accounts="customDomains"
							@remove="removeIntegration">
							<template slot-scope="slotProps">
								{{ slotProps.account.account_name }} <span v-bind:class="{ 'integration-status active': slotProps.account.is_active, 'integration-status inactive': !slotProps.account.is_active }">{{ isActiveLabel(slotProps.account.is_active) }}</span>
								<span
									class="integration-status-verify-btn"
									:class="{ 'is-loading dark': isVerifying(slotProps.account._id), 'hidden': slotProps.account.is_active }"
									@click="verifyDomain(slotProps.account._id)">Verify</span>
							</template>
						</integration-accounts>
					</div>

				</div>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- Custom Domain -->
		<modal
			class="integration-modal"
			:size="'large'"
			@close="isShowModalCustomDomains = false"
			v-if="isShowModalCustomDomains">
			<div slot="header"><h3>Custom Domain</h3></div>
			<div slot="body">
				<div class="row">
					<div class="col-md-6">
						<div class="integration-video embed-responsive embed-responsive-16by9">
							<iframe src="https://www.youtube.com/embed/JBegr4CgfQI?rel=0"></iframe>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<input
								type="text"
								class="input form-control"
								placeholder="Your existing domain"
								@input="onCustomDomainChange"
								v-model="customDomain">
							<div class="field-error" v-if="!isCustomDomainValid">Custom domain not valid</div>
						</div>
						<div class="integration-explanation">
							<div class="title">Edit your DNS Record & add CNAME Record with the following settings:</div>
							<div class="description"><i class="material-icons checklist">check</i> Name: your subdomain name (e.g: <span class="highlight">cart.yourdomain.com</span>)</div>
							<div class="description"><i class="material-icons checklist">check</i> TTL: <span class="highlight">14400</span></div>
							<div class="description"><i class="material-icons checklist">check</i> Type: <span class="highlight">CNAME</span></div>
							<div class="description"><i class="material-icons checklist">check</i> Record: <span class="highlight">{{ orderOnlineSite }}</span></div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalCustomDomains = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-primary" :disabled="customDomain.length === 0 || !isCustomDomainValid" :class="{ 'is-loading': isAddingCustomDomain }" @click="addCustomDomain">{{ $t('Save') }}</button>
			</div>
		</modal>
	</div>

	<notifications group="custom_domain" position="bottom right" />
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Modal from '../components/Modal.vue';
import IntegrationAccounts from '../components/IntegrationAccounts.vue';
import integrationApi from '../api/integration';
import { isValidURL } from '../lib/helper';

export default {
	name: 'settingsCustomDomain',
	components: {
		Modal,
		IntegrationAccounts,
	},
	data() {
		return {
			isShowModalCustomDomains: false,
			isAddingCustomDomain: false,
			isVerify: false,
			customDomain: '',
			isCustomDomainValid: true,
			verifyingItems: [],
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			updateAccount: 'settings/updateAccount',
			removeAccount: 'settings/removeAccount',
		}),
		removeIntegration(id) {
			this.removeAccount(id);
			const callback = (response) => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},
		addCustomDomain() {
			this.isAddingCustomDomain = true;
			const customDomain = this.customDomain ? this.customDomain.trim() : '';
			const params = { domain: customDomain };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.customDomain = '';
				this.isAddingCustomDomain = false;
				this.isShowModalCustomDomains = false;

				this.$notify({
					group: 'custom_domain',
					title: 'Custom Domain',
					text: 'Custom domain added, update your domain DNS & verify to connecting the domain',
					type: 'success',
				});
			};
			integrationApi.addCustomDomain(params, callback);
		},
		onCustomDomainChange() {
			// const hostName = this.customDomain.match(/^(?!:\/\/)([a-zA-Z0-9]+\.)?([a-zA-Z0-9]+\.)?[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,7}?$/i);
			// this.isCustomDomainValid = !!hostName;
			const domain = this.customDomain.trim();
			const isDomainValid = isValidURL(domain);
			this.isCustomDomainValid = isDomainValid;
		},
		isActiveLabel(isActive) {
			if (isActive) {
				return 'Connected';
			} else {
				return 'Not connected';
			}
		},
		verifyDomain(id) {
			this.verifyingItems.push(id);
			this.isVerify = true;
			const params = { integration_id: id };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.updateAccount(account);

					this.$notify({
						group: 'custom_domain',
						title: 'Custom Domain',
						text: `Successfully Connected to ${account.account_name}`,
						type: 'success',
					});
				}
				this.isVerify = false;
				this.removeVerifying(id);
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'custom_domain',
						title: 'Custom Domain',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isVerify = false;
				this.removeVerifying(id);
			};
			integrationApi.verifyCustomDomain(params, callback, errorCallback);
		},
		removeVerifying(id) {
			const index = this.verifyingItems.findIndex(item => item === id);
			if (index !== -1) {
				this.verifyingItems.splice(index, 1)
			}
		},
		isVerifying(id) {
			return this.verifyingItems.includes(id);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		customDomains() {
			return this.accounts.filter(account => account.name === 'custom_domain');
		},
		isCustomDomainsEmpty() {
			return this.customDomains.length === 0;
		},
		orderOnlineSite() {
			return `${this.user.username}.ostock.id`;
		},
	},
	created() {
		const isAccountsEmpty = this.accounts.length === 0;
		if (isAccountsEmpty && !this.isFetching) {
			this.fetchAccounts();
		}
	},
};
</script>
